import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import * as moment from 'moment';
import { Glyphicon, Button } from 'react-bootstrap';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IBillingReportResponse } from '@nkr/store/index';
import { ISortBy, IBillingReport } from '@nkr/models/index';
import { TableWrapper, HeaderColumnWrapper } from './styles';
import ItemRow from './item-row';
import DownloadReport from './download-report';
import { GridApi, ColumnApi, GridReadyEvent, CsvExportParams, ProcessHeaderForExportParams, ProcessCellForExportParams } from 'ag-grid-community';
import { ChargeTypes } from '@nkr/enums/index';

import * as DateTimeModule from "react-datetime";

const DateTime = (DateTimeModule as any).default;

interface IBillingReportRow extends IBillingReport {
    expanded: boolean
}

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBillingReport: (startDate: string, endDate: string) => Promise<IBillingReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: IBillingReportRow[],
    expandedRows: number[],
    export: boolean,
    startDate: string,
    endDate: string,
    center: string,
    status: number,
    sortBy: ISortBy[]
}

class AutomatedCollectionsClearing extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        expandedRows: [],
        export: false,
        startDate: __ENVIRONMENT__ == 'dev' ? '01/01/2018' : moment().subtract(1, 'months').format('MM/DD/YYYY'),
        endDate: __ENVIRONMENT__ == 'dev' ? moment().format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
        center: '',
        status: 0,
        sortBy: []
    }

    statusList = [
        { id: 0, name: 'All' },
        { id: 10, name: 'Pending' },
        { id: 15, name: 'Submitted to Recipient Center' },
        { id: 55, name: 'Submitted by Recipient Center' },
        { id: 20, name: 'Accepted' },
        { id: 30, name: 'Disputed' },
        { id: 40, name: 'Invoiced' },
        { id: 50, name: 'Not Invoiced' }
    ];

    componentWillMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getBillingReport(this.state.startDate, this.state.endDate).then((response: IBillingReportResponse) => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results.map(x => {
                            return { ...x, expanded: false }
                        })
                    })
                }

                this.props.hideLoading();
            });
        });
    }

    handleStartDateChange = (e: moment.Moment | string) => {
        let value = typeof e == 'string' ? e : e.format('MM/DD/YYYY');

        this.setState({
            startDate: value
        });
    }

    handleEndDateChange = (e: moment.Moment | string) => {
        let value = typeof e == 'string' ? e : e.format('MM/DD/YYYY');

        this.setState({
            endDate: value
        });
    }

    handleCenterChange = (e: React.FormEvent<HTMLSelectElement>) => {
        this.setState({
            center: e.currentTarget.value
        });
    }

    handleStatusChange = (e: React.FormEvent<HTMLSelectElement>) => {
        this.setState({
            status: parseInt(e.currentTarget.value)
        });
    }

    handleRefresh = () => {
        this.getData();
    }

    handleExpand = (id: number, expanded: boolean) => {
        let expandedRows = [...this.state.expandedRows];

        if (expanded)
            expandedRows = this.state.expandedRows.filter(item => item != id);
        else
            expandedRows.push(id);

        this.setState({
            expandedRows
        });
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);
        let sort = sortBy.find(item => item.property == property);

        if (sort != null) {
            if (sort.direction == 'asc')
                sort.direction = 'desc'
            else
                if (sort.direction == 'desc')
                    sortBy = sortBy.filter(item => item.property != property);
        } else {
            sortBy.push({ property, direction: 'asc' });
        }

        this.setState({
            sortBy
        });
    }

    filterRows = () => {
        if (this.state.center == '' && this.state.status == 0)
            return this.state.list;
        else {
            return this.state.list.filter(item => {
                let matchesCenter = this.state.center != '' ? item.donorCenterAlias == this.state.center || item.recipientCenterAlias == this.state.center : true;
                let matchesStatus = this.state.status > 0 ? item.status == this.state.status : true;

                return matchesCenter && matchesStatus;
            });
        }
    }

    renderHeaderSort = (property: string) => {
        let sortItem = this.state.sortBy.find(item => item.property == property);

        if (sortItem != null) {
            return <Glyphicon glyph={sortItem.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    getClaimType = (data: IBillingReport) => {
        let { isSbs, isMedicare, isMedicaid, isGlobal } = data;

        let claimType = '';

        if (isSbs)
            claimType = 'SBS';

        if (isMedicare)
            claimType = 'Medicare';

        if (isMedicaid)
            claimType = 'Medicaid';

        if (isGlobal)
            claimType = 'Global'

        if (!isSbs && !isMedicare && !isMedicaid && !isGlobal)
            return 'Non-Global';

        return claimType;
    }

    getChargeAmount = (data: IBillingReport, charges: number, chargeType: ChargeTypes) => {
        let { isSbs, isMedicare, isMedicaid, isGlobal, asaUnitPrice, asaUnits } = data;

        if (isSbs) {
            return charges;
        }

        if (isMedicare) {
            return 0;
        }

        if (isMedicaid) {
            if (chargeType == ChargeTypes.PHYSICIAN_CHARGES) {
                return 0;
            } else {
                return 0;
            }
        }

        if (isGlobal) {
            if (chargeType == ChargeTypes.PHYSICIAN_CHARGES) {
                return charges;
            } else {
                return asaUnitPrice * asaUnits;
            }
        }

        if (!isSbs && !isMedicare && !isMedicaid && !isGlobal) {
            return 0;
        }
    }

    getClaimAmount = (data: IBillingReport) => {
        const physicianCharges = this.getChargeAmount(data, data.physicianCharges, ChargeTypes.PHYSICIAN_CHARGES);
        const anesthesiaCharges = this.getChargeAmount(data, data.anesthesiaCharges, ChargeTypes.ANESTHESIA_CHARGES);
        const hospitalCharges = data.hospitalCharges;
        const claimAmount = (physicianCharges + anesthesiaCharges + hospitalCharges).toLocaleString('en', { minimumFractionDigits: 2 });

        return claimAmount;
    }

    getStatus = (data: IBillingReport) => {
        switch (data.status) {
            case 10: return 'Pending';
            case 15: return 'Submitted to Recipient Center';
            case 20: return 'Accepted';
            case 30: return 'Disputed';
            case 40: return 'Invoiced';
            case 50: return 'Not Invoiced';
        }
    }

    dateComparator = (date1: string, date2: string) => {
        var date1Number = parseInt(moment(date1).format('YYYYMMDD'));
        var date2Number = parseInt(moment(date2).format('YYYYMMDD'));

        if (date1 === '' && date2 === '') {
            return 0;
        }

        if (date1 === '') {
            return -1;
        }

        if (date2 === '') {
            return 1;
        }

        return date1Number - date2Number;
    }

    render = () => {
        const filteredRows = this.filterRows();

        const sortByProperties = this.state.sortBy.map((sortBy) => sortBy.property);

        const sortByDirections = this.state.sortBy.map((sortBy) => sortBy.direction);

        const sortedRows = this.state.sortBy.length > 0 ? _.orderBy(filteredRows, item => {
            let retVal = sortByProperties.map(property => {
                if (property == 'transplantDate')
                    return parseInt(moment(item.transplantDate).format('YYYYMMDD'));

                return item[property];
            });

            return retVal;
        }, sortByDirections) : filteredRows;

        const centers = _.uniq(this.props.reports.billingReport.map(x => x.donorCenterAlias)).sort();

        return (
            <>
                <div style={{ fontSize: 28, fontWeight: 500, marginBottom: 20 }}>CCB</div>

                <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>Center:</div>
                        <div style={{ marginRight: 20 }}>
                            <select className='form-control' onChange={this.handleCenterChange}>
                                <option value=''>All Centers</option>
                                {centers.map((center, index) =>
                                    <option value={center}>{center}</option>
                                )}
                            </select>
                        </div>

                        <div style={{ marginRight: 5 }}>Status:</div>
                        <div style={{ marginRight: 10 }}>
                            <select className='form-control' onChange={this.handleStatusChange}>
                                {this.statusList.map((item, index) =>
                                    <option value={item.id}>{item.name}</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 5 }}>Start Date:</div>
                        <div style={{ marginRight: 20 }}>
                            <DateTime
                                value={this.state.startDate}
                                input={true}
                                dateFormat={'MM/DD/YYYY'}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ style: { width: 140 } }}
                                onChange={this.handleStartDateChange}
                            />
                        </div>

                        <div style={{ marginRight: 5 }}>End Date:</div>
                        <div style={{ marginRight: 10 }}>
                            <DateTime
                                value={this.state.endDate}
                                input={true}
                                dateFormat={'MM/DD/YYYY'}
                                timeFormat={false}
                                closeOnSelect={true}
                                inputProps={{ style: { width: 140 } }}
                                onChange={this.handleEndDateChange}
                            />
                        </div>

                        <div>
                            <Button bsStyle='primary' onClick={this.handleRefresh}>Refresh</Button>
                        </div>
                    </div>

                    <DownloadReport
                        data={{
                            items: sortedRows
                        }}
                    />
                </div>

                <TableWrapper className='table table-striped'>
                    <thead>
                        <tr style={{ borderBottom: '0 none' }}>
                            <HeaderColumnWrapper rowSpan={2} style={{ borderRight: '1px solid white' }}>Show<br />Detail</HeaderColumnWrapper>
                            <HeaderColumnWrapper colSpan={3} style={{ borderRight: '1px solid white' }}>Donor</HeaderColumnWrapper>
                            <HeaderColumnWrapper colSpan={2}>Recipient</HeaderColumnWrapper>
                        </tr>
                        <tr>
                            <HeaderColumnWrapper style={{ width: '8%' }} onClick={() => this.handleSort('donorCenterAlias')}>
                                Center {this.renderHeaderSort('donorCenterAlias')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%' }} onClick={() => this.handleSort('donorAlias')}>
                                Alias {this.renderHeaderSort('donorAlias')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%', borderRight: '1px solid white' }} onClick={() => this.handleSort('donorUnosId')}>
                                UNOS ID {this.renderHeaderSort('donorUnosId')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%' }} onClick={() => this.handleSort('recipientCenterAlias')}>
                                Center {this.renderHeaderSort('recipientCenterAlias')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%', borderRight: '1px solid white' }} onClick={() => this.handleSort('recipientAlias')}>
                                Alias {this.renderHeaderSort('recipientAlias')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%' }} onClick={() => this.handleSort('swapNumber')}>
                                Swap # {this.renderHeaderSort('swapNumber')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '7%' }} onClick={() => this.handleSort('transplantDate')}>
                                TXP Date {this.renderHeaderSort('transplantDate')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '7%' }} onClick={() => this.handleSort('physicianCharges')}>
                                Date<br />Submitted {this.renderHeaderSort('physicianCharges')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '7%' }} onClick={() => this.handleSort('anesthesiaCharges')}>
                                Date<br />Disputed {this.renderHeaderSort('anesthesiaCharges')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%' }} onClick={() => this.handleSort('hospitalCharges')}>
                                Claim Type {this.renderHeaderSort('hospitalCharges')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '8%' }} onClick={() => this.handleSort('amount')}>
                                Claim Amount {this.renderHeaderSort('amount')}
                            </HeaderColumnWrapper>
                            <HeaderColumnWrapper style={{ width: '11%' }} onClick={() => this.handleSort('status')}>
                                Status {this.renderHeaderSort('status')}
                            </HeaderColumnWrapper>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedRows.map((row, index) =>
                            <ItemRow
                                key={index}
                                data={row}
                                expanded={this.state.expandedRows.find(item => item == row.donorId) != null}
                                onExpand={this.handleExpand}
                            />
                        )}

                        {sortedRows.length == 0 ?
                            <tr>
                                <td colSpan={13} style={{ textAlign: 'center', padding: 8 }}>
                                    <span>We couldn't find any billable items using the specified filters...</span>
                                </td>
                            </tr>
                            : null}
                    </tbody>
                </TableWrapper>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBillingReport: (start, end) => {
            return dispatch(ReportActionCreators.getBillingReport(start, end));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AutomatedCollectionsClearing);